(function () {
  if (window.musayoQuizBound) return;
  window.musayoQuizBound = true;

  // Parole chiave di custom.famiglia_olfattiva per ciascuna risposta.
  var FAMILIES = {
    fresca: ['agrum', 'aromat', 'acquat'],
    floreale: ['floreal', 'musch', 'aldeid'],
    calda: ['ambrat', 'oriental', 'gourmand'],
    legnosa: ['legnos', 'chypre']
  };
  var LEVELS = ['leggera', 'equilibrata', 'intensa'];
  var SHOWN = 4;

  function scrollToElement(element) {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    element.scrollIntoView({ behavior: reduced ? 'instant' : 'smooth', block: 'start' });
  }

  function familyOf(word) {
    return Object.keys(FAMILIES).filter(function (key) {
      return FAMILIES[key].some(function (stem) {
        return word.indexOf(stem) !== -1;
      });
    })[0];
  }

  // Concentrazione e titolo: "Extrait", "Elixir", "Intense" pesano; EDT e Cologne no.
  function intensityOf(text) {
    if (/extrait|elixir|intens/.test(text)) return 'intensa';
    if (/toilette|cologne/.test(text)) return 'leggera';
    return 'equilibrata';
  }

  // Famiglia principale (prima parola) 4, secondaria 2.
  function familyPoints(item, famiglia) {
    if (famiglia === 'tutte') return 0;
    var words = item.dataset.family.split(/[\s\/]+/).filter(Boolean);
    if (words.length && familyOf(words[0]) === famiglia) return 4;
    return words.some(function (word) { return familyOf(word) === famiglia; }) ? 2 : 0;
  }

  // Intensità giusta 2, vicina 1; a parità vince il bestseller.
  function otherPoints(item, intensita) {
    var points = item.dataset.bestseller ? 0.5 : 0;
    if (intensita !== 'tutte') {
      var gap = Math.abs(LEVELS.indexOf(intensityOf(item.dataset.concentration)) - LEVELS.indexOf(intensita));
      points += gap === 0 ? 2 : gap === 1 ? 1 : 0;
    }
    return points;
  }

  function show(root) {
    var form = root.querySelector('[data-quiz-form]');
    var results = root.querySelector('[data-quiz-results]');
    var list = root.querySelector('[data-quiz-list]');
    var data = new FormData(form);
    var per = data.get('per');
    var famiglia = data.get('famiglia');
    var intensita = data.get('intensita');
    var items = Array.prototype.slice.call(list.querySelectorAll('[data-quiz-item]'));

    var ranked = items
      .filter(function (item) {
        var gender = item.dataset.gender;
        return per === 'tutti' || gender === per || gender === 'unisex';
      })
      .map(function (item) {
        var family = familyPoints(item, famiglia);
        return { item: item, family: family, points: family + otherPoints(item, intensita), order: Number(item.dataset.order) };
      })
      .sort(function (a, b) {
        return b.points - a.points || a.order - b.order;
      })
      .slice(0, SHOWN);

    items.forEach(function (item) {
      item.hidden = true;
    });
    ranked.forEach(function (entry) {
      entry.item.hidden = false;
      list.appendChild(entry.item);
    });

    // Famiglia scelta ma nessuna fragranza la contiene: lo diciamo invece di fingere.
    var title = root.querySelector('[data-quiz-title]');
    var exact = famiglia === 'tutte' || (ranked.length && ranked[0].family > 0);
    title.textContent = ranked.length ? (exact ? title.dataset.exact : title.dataset.near) : title.dataset.empty;

    results.hidden = false;
    results.focus({ preventScroll: true });
    scrollToElement(results);
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-quiz-form]');
    if (!form) return;
    event.preventDefault();
    show(form.closest('[data-musayo-quiz]'));
  });

  document.addEventListener('click', function (event) {
    var reset = event.target.closest('[data-quiz-reset]');
    if (!reset) return;
    var root = reset.closest('[data-musayo-quiz]');
    var form = root.querySelector('[data-quiz-form]');
    form.reset();
    root.querySelector('[data-quiz-results]').hidden = true;
    scrollToElement(form);
    form.querySelector('input').focus({ preventScroll: true });
  });
})();
